// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"26cbc8fb","117":"0376471a","141":"c5ea3362","143":"7db19d64","179":"56a1d7a0","345":"765e1d22","365":"77657a23","525":"ef441e0f","669":"001b2226","794":"533cf058","795":"1e455f23","839":"32cda754","861":"b935adb2","921":"ed19eb82"}[chunkId] + ".css";
};